const initializeKameleoonRuntime = async () => {
  const { Kameleoon } = window;
  if (Kameleoon && Kameleoon?.Analyst?.load && !Kameleoon?.Internals?.runtime) {
    await Kameleoon.Analyst.load();
  }
};

export const sendKameleoonPurchaseEvent = (quoteTotal) => {
  if (window.Kameleoon) {
    try {
      const FIGO_GOAL_ID = process.env.REACT_APP_KAMELEOON_GOAL_ID;
      window.Kameleoon.API.Goals.processConversion(FIGO_GOAL_ID, quoteTotal);
      // eslint-disable-next-line no-console
      console.log('[Kameleoon] - Purchase Event fired');
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log('[Kameleoon] - Error processing conversion', error);
    }
  }
};

export const sendKameleoonVisitedPageEvent = async (pageOrUrl = '') => {
  const cleanedurl = pageOrUrl.slice(1).replace(/\//g, '_');
  const eventTemplate = `event_${cleanedurl}_viewed`;
  const { Kameleoon } = window;
  await initializeKameleoonRuntime();

  if (Kameleoon?.API?.Events?.trigger) {
    try {
      Kameleoon.API.Events.trigger(eventTemplate);
      // eslint-disable-next-line no-console
      console.log(`[Kameleoon] - Event fired: ${eventTemplate}`);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log('[Kameleoon] - Event firing error:', error.toString());
    }
  }
};
